import { FC, useCallback, useMemo, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { PrivacyPolicyModalContainer } from '../PrivacyPolicyModal';
import { AnalyticsEventName } from '@/api/analytics';
import { Button } from '@/components/buttons';
import { useAnalytics } from '@/hooks/analytics';
import useEstonia from '@/hooks/estonia';
import { usePopupAfterRegSlide } from '@/hooks/popup';
import { useInactiveUser } from '@/hooks/user';
import { useCommonStore } from '@/store';

import { ScCookie, ScLink } from './styles';

export type CookieModalProps = {
  onClose: () => void;
};

export const CookiesModal: FC<CookieModalProps> = ({ onClose }) => {
  const { t } = useTranslation('common');
  const { sendEventToAnalytics } = useAnalytics();

  const { isUserInactive } = useInactiveUser();
  const { hidePopup } = usePopupAfterRegSlide();
  const { isEstonia } = useEstonia();

  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const [isOpenPolicy, setIsOpenPolicy] = useState(false);

  const onClosePolicy = useCallback(() => {
    setIsOpenPolicy((s) => !s);
    sendEventToAnalytics({ name: AnalyticsEventName.COOKIE_BANNER });
  }, [sendEventToAnalytics]);

  const buttonProps = useMemo(() => {
    return isMobileDevice
      ? { wide: true }
      : {
          autoPaddingHorizontal: true,
          paddingX: 12,
        };
  }, [isMobileDevice]);

  const cookieText = useMemo(
    () => (
      <Trans i18nKey="common:modals.cookie">
        We use cookies to improve your experience. By using our website you are
        accepting our <ScLink onClick={onClosePolicy}>Cookie Policy</ScLink>
      </Trans>
    ),
    [onClosePolicy]
  );

  return (
    <>
      <ScCookie
        hide={hidePopup && !isUserInactive}
        largeBottomMargin={isEstonia}
      >
        <div>{cookieText}</div>
        <Button {...buttonProps} primary xSmall onClick={onClose}>
          {t('button.continue')}
        </Button>
      </ScCookie>
      {isOpenPolicy && <PrivacyPolicyModalContainer onClose={onClosePolicy} />}
    </>
  );
};
